import { usePreloadImages } from "@hooks/usePreloadImages";
import { DATA } from "./data";
import styles from "./styles.module.scss";
import { DATA as focusAreasData } from "../focusAreas/data";
import body from "../focusAreas/img/body.png";

export const FitnessLevel = ({ onNextStep, onTrackEvent }) => {
  usePreloadImages([...Object.values(focusAreasData), body]);

  const handleNextStep = (key, value) => {
    console.log(value);
    onNextStep(key);
    onTrackEvent(value);
  };
  return (
    <div className={styles.container}>
      <h2>What is your fitness level?</h2>
      <div className={styles.cards}>
        {Object.entries(DATA).map(([key, value]) => (
          <div
            onClick={() => handleNextStep(key, value)}
            key={key}
            className={styles.card}
          >
            {value}
          </div>
        ))}
      </div>
    </div>
  );
};
